import React, {useContext} from 'react';
import navStyle from './style';
import {Link} from 'react-router-dom';
import {GlobalContext} from '../../utilities/GlobalContext';
import DesctopNav from './DesctopNav';
import MobileNav from './MobileNav';
import signOut from '../../api/auth/signOut';

export default function Nav({navDetails}) {
	let isMobile = useContext(GlobalContext).isMobile;
	let currentSize = useContext(GlobalContext).size;
	let serverOrigin = useContext(GlobalContext).serverOrigin;
	let setUser = useContext(GlobalContext).setUser;

	if (isMobile || currentSize === 'sm' || currentSize === 'md') {
		return <MobileNav navDetails={navDetails} signOutPressed={signOutPressed} />;
	} else {
		return <DesctopNav navDetails={navDetails} signOutPressed={signOutPressed} />;
	}

	function signOutPressed() {
		signOut(setUser, serverOrigin)
			.then(() => {
				alert('Successfully signed out');
			})
			.catch(() => {
				alert('Sign out failed');
			});
	}
}
